
import { Component, Emit, Inject, InjectReactive, Prop } from "vue-property-decorator";
import { BaseQuick } from "../lib/core";
import { FindRouter, ObjectHelper, PermissionHelper, QuickHelper } from "@root/core";
import { debounce } from "@root/core/decorators/debounce";

@Component
export default class QuickList extends BaseQuick {
    @Prop({ type: Object, required: false })
    params: any;

    @Prop({ type: Boolean, default: false })
    disableCard!: boolean;

    /// config
    @Prop({ type: Boolean, default: true })
    showChildren!: boolean;

    @Emit("updated")
    doUpdatedUpdate(value) {
        return value;
    }

    /// private helpers
    @Inject({ default: null })
    readonly prefix!: string | null;

    // selected row
    selected: NonNullable<any> | null = null;
    @debounce(300)
    setSelected(value) {
        this.selected = value;
    }

    // portal
    @Prop({ type: Number, required: false })
    portalKey!: number;
    @InjectReactive()
    readonly autoQuickInstance!: Vue | undefined;
    get portal() {
        const autoId = (this.autoQuickInstance as any)?.autoComponentId;
        return autoId ? `${autoId}_${this.portalKey}` : this.toolboxId;
    }
    get toolboxId() {
        return `toolbox-${this._uid}`;
    }

    /// icon
    get routeIcon(): string | null {
        const path = this.$route.path;

        let routers = FindRouter({ path });
        if (routers.length === 0) return null;
        return routers[routers.length - 1].icon as string;
    }

    // server params CRUD
    get serverC() {
        const params = ObjectHelper.deepClone(this.params);
        /// delete the `where` on `C`.
        delete params?.where;
        return QuickHelper.serverC(this.quick, params);
        // return {
        //     server: {
        //         path: this.quick.path,
        //         method: "C",
        //         params: this.quick.paramsCreate?.call(this.quick),
        //     },
        //     ...(this.params ? { value: this.params.where } : {}),
        // };
    }

    get serverR() {
        return QuickHelper.serverR(this.quick, null, this.params);
    }
    serverU(id) {
        return QuickHelper.serverU(this.quick, id);
    }
    serverD(id) {
        return QuickHelper.serverD(this.quick, id, this.params);
        // return {
        //     server: {
        //         path: this.quick.path,
        //         method: "D",
        //         /// paramsDelete may return mutable value should not be cloned.
        //         params: ObjectHelper.deepMerge(
        //             this.quick.paramsDelete?.call(this.quick),
        //             this.autoWhereId(id),
        //         ),
        //     },
        // };
    }

    /// ref CRUD
    ref(type: string, key?: any) {
        const id = `ref-${type}-${key}`;
        let ref = this.$refs[id];
        if (Array.isArray(ref)) ref = ref[0];
        const result = { id, ref };
        return result;
    }
}
